/** Clef `localStorage` du theme choisi : 'dark' ou 'light'. */
export const CLE_THEME = 'theme';

/**
 * Theme au demarrage : le choix sauvegarde, sinon celui du systeme.
 *
 * Meme regle que le script de `index.html`, qui pose la classe `dark` avant le premier
 * rendu — un test verifie qu'ils concordent.
 */
export function themeInitial(): 'dark' | 'light' {
    try {
        const sauvegarde = localStorage.getItem(CLE_THEME);
        if (sauvegarde === 'dark' || sauvegarde === 'light') return sauvegarde;
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    } catch {
        return 'light';
    }
}
